import styled from "styled-components";
import media from "styled-media-query";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);
  height: 340px;
  width: 100%;

  .image {
    width: 100%;
    height: 140px;
    background: linear-gradient(135deg, #f0f4f9 0%, #e6eef8 100%);
  }

  .body {
    padding: 16px;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .category {
    width: 80px;
    height: 16px;
    border-radius: 20px;
    margin-bottom: 8px;
  }

  .title {
    width: 90%;
    height: 40px;
    border-radius: 8px;
    margin-bottom: 15px;
  }

  .price {
    width: 60%;
    height: 26px;
    border-radius: 8px;
    margin-bottom: 20px;
  }

  .button {
    width: 100%;
    height: 40px;
    border-radius: 10px;
    margin-top: auto;
  }
  
  ${media.lessThan('medium')`
    height: 320px;
    
    .image {
      height: 120px;
    }
    
    .title {
      height: 36px;
    }
    
    .button {
      height: 36px;
    }
  `}
`;
